import { create } from 'zustand'

export interface Toast {
  id: string
  message: string
  type?: 'success' | 'error' | 'info'
}

interface UIState {
  toasts: Toast[]
  addToast: (message: string, type?: Toast['type']) => void
  removeToast: (id: string) => void
  navHidden: boolean
  setNavHidden: (hidden: boolean) => void
  navTheme: 'default' | 'dark'
  setNavTheme: (theme: 'default' | 'dark') => void
  motionReduced: boolean
  setMotionReduced: (reduced: boolean) => void
  bagPulse: number
  pulseBag: () => void
  authModalOpen: boolean
  authModalReturnTo: string | null
  openAuthModal: (returnTo?: string) => void
  closeAuthModal: () => void
}

const prefersReducedMotion =
  typeof window !== 'undefined' &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches

export const useUIStore = create<UIState>()((set) => ({
  toasts: [],
  navHidden: false,
  setNavHidden: (hidden) => set({ navHidden: hidden }),
  navTheme: 'default',
  setNavTheme: (theme) => set({ navTheme: theme }),
  motionReduced: prefersReducedMotion,
  setMotionReduced: (reduced) => set({ motionReduced: reduced }),
  bagPulse: 0,
  pulseBag: () => set((state) => ({ bagPulse: state.bagPulse + 1 })),
  authModalOpen: false,
  authModalReturnTo: null,
  openAuthModal: (returnTo) => set({ authModalOpen: true, authModalReturnTo: returnTo ?? null }),
  closeAuthModal: () => set({ authModalOpen: false, authModalReturnTo: null }),
  addToast: (message, type = 'info') => {
    const id = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 7)}`
    set((state) => ({ toasts: [...state.toasts, { id, message, type }] }))
    setTimeout(() => {
      set((state) => ({
        toasts: state.toasts.filter((t) => t.id !== id),
      }))
    }, 3000)
  },
  removeToast: (id) =>
    set((state) => ({
      toasts: state.toasts.filter((t) => t.id !== id),
    })),
}))
